import { jsx as _jsx } from "react/jsx-runtime";
import { Check, Info } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { DropdownMenu, renderDropdownItems } from "@air/primitive-dropdown-menu";
import { Tooltip } from "@air/primitive-tooltip";
import { memo, useMemo } from "react";
import { VideoFrameCount } from "~/components/AssetModal/Visualizer/VideoVisualizer/VideoVisualizerInner/components/VideoFrameCount";
import { VideoStandardTime } from "~/components/AssetModal/Visualizer/VideoVisualizer/VideoVisualizerInner/components/VideoStandardTime";
import { VideoTimecode } from "~/components/AssetModal/Visualizer/VideoVisualizer/VideoVisualizerInner/components/VideoTimecode";
import { useVideoTimeFormatContext, VideoTimeFormat } from "~/providers/VideoTimeFormatProvider";
export const VideoTimeFormatMenu = /*#__PURE__*/ memo((param)=>{
    let { currentTime, frameCount, totalTime } = param;
    const { format, handleUpdateFormat } = useVideoTimeFormatContext();
    const formatOptions = useMemo(()=>{
        const formatOptionsArray = [
            {
                id: "time-format",
                label: "Time Format",
                type: "title"
            },
            {
                id: VideoTimeFormat.Standard,
                label: "Standard",
                onSelect: ()=>handleUpdateFormat(VideoTimeFormat.Standard),
                suffix: format === VideoTimeFormat.Standard ? /*#__PURE__*/ _jsx(Check, {
                    className: "size-4 text-blue-9"
                }) : undefined,
                type: "item"
            },
            {
                id: VideoTimeFormat.Frames,
                disabled: !frameCount,
                label: "Frames",
                onSelect: ()=>handleUpdateFormat(VideoTimeFormat.Frames),
                suffix: !frameCount ? /*#__PURE__*/ _jsx(Tooltip, {
                    delayDuration: 0,
                    label: "Frame count is not available for this video",
                    children: /*#__PURE__*/ _jsx(Info, {
                        className: "hidden size-4 group-hover/dropdown-menu-item:block"
                    })
                }) : format === VideoTimeFormat.Frames ? /*#__PURE__*/ _jsx(Check, {
                    className: "size-4 text-blue-9"
                }) : undefined,
                type: "item"
            },
            {
                id: VideoTimeFormat.Timecode,
                label: "Timecode",
                onSelect: ()=>handleUpdateFormat(VideoTimeFormat.Timecode),
                suffix: format === VideoTimeFormat.Timecode ? /*#__PURE__*/ _jsx(Check, {
                    className: "size-4 text-blue-9"
                }) : undefined,
                type: "item"
            }
        ];
        return formatOptionsArray;
    }, [
        format,
        frameCount,
        handleUpdateFormat
    ]);
    return /*#__PURE__*/ _jsx(DropdownMenu, {
        trigger: /*#__PURE__*/ _jsx(Button, {
            appearance: "ghost",
            color: "grey",
            "data-testid": "VIDEO_TIME_FORMAT",
            style: {
                fontFeatureSettings: "'tnum' on"
            },
            size: "small",
            children: format === VideoTimeFormat.Frames && frameCount && totalTime ? /*#__PURE__*/ _jsx(VideoFrameCount, {
                currentTime: currentTime,
                frameCount: frameCount,
                totalTime: totalTime
            }) : format === VideoTimeFormat.Timecode ? /*#__PURE__*/ _jsx(VideoTimecode, {
                currentTime: currentTime,
                frameCount: frameCount,
                totalTime: totalTime
            }) : /*#__PURE__*/ _jsx(VideoStandardTime, {
                currentTime: currentTime,
                totalTime: totalTime
            })
        }),
        children: renderDropdownItems({
            options: formatOptions
        })
    });
});
VideoTimeFormatMenu.displayName = "VideoTimeFormatMenu";
